import { createReducer } from '@api/createRequestStore';
import * as types from './types';

export default createReducer(types.SCOPE);
